// src/pages/TestPage.jsx

import React from "react";
import Subpage from "../components/Subpage";  // Adjust the path based on your project structure

export default function TestPage() {
  const relatedLinks = [
    { href: "/games", title: "View All Games" },
    { href: "/devlog", title: "Read Devlog" },
  ];

  return (
    <Subpage
      title="Test Page Title"
      content="This is a test page to demonstrate the Subpage layout. You can add any content here."
      relatedLinks={relatedLinks}
    />
  );
}
